module.exports = __webpack_public_path__ + "static/media/system.a926637e.svg";